"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavWidgetItem = void 0;
const Link_1 = __importDefault(require("@mui/material/Link"));
const react_1 = __importDefault(require("react"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const NavWidgetItem_styled_1 = require("./NavWidgetItem.styled");
function NavWidgetItem({ title, description, icon, linkType, linkAction, onClick, isLoading = false, }) {
    const getLinkProps = () => {
        const iconProps = {
            internal: {
                children: icon,
                to: linkAction,
                component: NavWidgetItem_styled_1.RouterLink,
                onClick,
            },
            external: {
                children: icon,
                href: linkAction,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick,
            },
            download: {
                children: icon,
                onClick: linkAction,
                component: "button",
                variant: "body1",
            },
        }[linkType];
        const linkProps = {
            internal: {
                component: NavWidgetItem_styled_1.RouterLink,
                children: title,
                to: linkAction,
                onClick,
            },
            external: {
                children: title,
                href: linkAction,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick,
            },
            download: {
                children: title,
                onClick: linkAction,
                component: NavWidgetItem_styled_1.Title,
                variant: "body1",
            },
        }[linkType];
        return [linkProps, iconProps];
    };
    const [linkProps, iconProps] = getLinkProps();
    return (react_1.default.createElement(NavWidgetItem_styled_1.Card, null,
        isLoading ? (react_1.default.createElement(NavWidgetItem_styled_1.Loader, null,
            react_1.default.createElement(CircularProgress_1.default, { color: "secondary" }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Link_1.default, { "aria-label": title, ...iconProps }))),
        react_1.default.createElement(NavWidgetItem_styled_1.Column, null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NavWidgetItem_styled_1.TitleLink, { ...linkProps })),
            react_1.default.createElement(Typography_1.default, { variant: "caption", style: {
                    letterSpacing: 0.4,
                    lineHeight: 1.33,
                    minHeight: 64,
                } }, description))));
}
exports.NavWidgetItem = NavWidgetItem;
